// extracted by mini-css-extract-plugin
export default {"Checkbox":"CheckboxWidget_Checkbox__GpBQL","errorText":"CheckboxWidget_errorText__Trd12"};